class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static stickyHeader = document.querySelector('sticky-header');

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static onClickDropdownSort(element) {
    if(!element.classList.contains('selected')) {
      const details = element.closest('details');
      const sortByElement = document.getElementById(details.dataset.sort);
      details.querySelector('.selected').classList.remove('selected');
      element.classList.add('selected');
      sortByElement.value = element.dataset.value;
      sortByElement.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    if(FacetFiltersForm.stickyHeader) FacetFiltersForm.stickyHeader.preventResize = true;
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    if(FacetFiltersForm.stickyHeader) FacetFiltersForm.stickyHeader.preventResize = false;
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    productGridContainer.innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    if(FacetFiltersForm.stickyHeader) FacetFiltersForm.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    if(!productGridContainer.dataset.ignoreScrollOnDesktop || window.innerWidth < 990) {
      productGridContainer.scrollIntoView({behavior: 'smooth'});
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      const countDesktop = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountDesktop').innerHTML;
      containerDesktop.innerHTML = countDesktop;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.parentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetDetailsElementsFromFetch.forEach((elementToRender, index) => {
      if(event && event.target.closest('.js-filter') && event.target.closest('.js-filter').id === elementToRender.id) return;
      const currentElement = document.getElementById(elementToRender.id);
      if(currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetDetailsElementsFromFetch[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).parentElement.after(elementToRender.parentElement);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.parentElement.id} .js-filter`).parentElement.before(elementToRender.parentElement);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');
    if (sourceElement && targetElement) {
      targetElement.outerHTML = sourceElement.outerHTML;
    }

    const targetElementStr = target.querySelector('.facets__selected-str');
    const sourceElementStr = source.querySelector('.facets__selected-str');
    if (sourceElementStr && targetElementStr) {
      targetElementStr.outerHTML = sourceElementStr.outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const gtePrice = form.querySelector('.field__input--price-gte');
    if(gtePrice && gtePrice.value == gtePrice.min) {
      formData.delete(gtePrice.name);
    }
    
    const ltePrice = form.querySelector('.field__input--price-lte');
    if(ltePrice && (ltePrice.value * 1.00) == (ltePrice.max * 1.00)) {
      formData.delete(ltePrice.name);
    }

    if(form.dataset.defaultSortBy && form.dataset.defaultSortBy == formData.get('sort_by')) {
      formData.delete('sort_by');
    }
    return new URLSearchParams(formData).toString();
  }
  
  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            if(event.target.closest('form').id == 'FacetSortForm') {
              forms.push(this.createSearchParams(form));
            } else {
              forms.push(this.createSearchParams(form));
            }
          } else if(event.target.closest('form').id == 'FacetSortForm') {
            const sortMobile = form.querySelector('[name="sort_by"]');
            if(sortMobile) {
              sortMobile.value = event.target.value;
            }
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.filter(ele => ele).join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

function getElementStyle(element, property) {
  return window.getComputedStyle ? window.getComputedStyle(element, null).getPropertyValue(property) : element.style[property.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); })];
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input:not([type="range"])')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.querySelectorAll('input[type="range"]').forEach(element => {
      element.addEventListener('input', this.onRangeSliderInput.bind(this));
    });  
    this.setMinAndMaxValues();
  }

  onRangeSliderInput(event) {
    const remainInput = document.getElementById(event.target.dataset.rangeInput);
    let delta = 0;
    if(event.target.classList.contains('range-slider__input--lower')) {
      if(Number.parseInt(event.target.value) >= Number.parseInt(remainInput.value)) {
        delta = -1;
      }
    } else {
      if(Number.parseInt(event.target.value) <= Number.parseInt(remainInput.value)) {
        delta = 1;
      }
    }
    if(delta == 0) {
      this.calculateRangeUsedBarWidth(event.target);
    } else {
      event.target.value = Number.parseInt(remainInput.value) + delta;
    }
    document.getElementById(event.target.dataset.input).value = event.target.value / 100;

    const rangeValueElement = document.getElementById(event.target.dataset.rangeValue);
    rangeValueElement.innerHTML = Shopify.showPrice(event.target.value);
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    const rangeInputElement = document.getElementById(event.target.dataset.rangeInput);
    rangeInputElement.value = event.target.value;
    this.calculateRangeUsedBarWidth(rangeInputElement);
  }

  calculateRangeUsedBarWidth(rangeInput) {
    const value = Number(rangeInput.value);
    const max = Number(rangeInput.getAttribute('max'));
    let rangeUsedBarWidth;
    if(rangeInput.classList.contains('range-slider__input--lower')) {
      rangeUsedBarWidth = (value * 100.00) / max;
      this.style.setProperty('--range-used-start-width', rangeUsedBarWidth + '%');
    } else {
      const min = Number(rangeInput.getAttribute('min'));
      rangeUsedBarWidth = ((max - value) * 100.00) / (max - min);
      this.style.setProperty('--range-used-end-width', rangeUsedBarWidth + '%');
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input:not([type="range"])');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* Ortholuxe Accessories: one OR source, original visual sections. Draft test only. */
const OrtholuxeAccessoryOR = {
  source: 'filter.p.m.custom.accessory_subtype',
  parent: 'filter.p.product_type',
  desk: 'filter.p.m.custom.desk_type',
  table: 'filter.p.m.custom.table_type',
  familyKey: 'ol_family', deskKey: 'ol_desk', tableKey: 'ol_table',
  aliases: {
    'desks':'Desks', 'accent & side tables':'Tables', 'artificial plants':'Artificial Plants',
    'clocks':'Clocks', 'coat racks':'Coat Racks', 'coffee tables':'Coffee Tables',
    'console tables':'Console Tables', 'curtains & cushions':'Curtains & Cushions',
    'lighting':'Lighting', 'mirrors':'Mirrors', 'office cubicle':'Office Workstations',
    'office workstations':'Office Workstations', 'ladder':'Step Stools', 'step stools':'Step Stools'
  },
  parentMap: new Map([
    ['gid://shopify/FilterSettingGroup/135069798','Desks'],
    ['gid://shopify/FilterSettingGroup/135135334','Tables']
  ]),
  values: [], baselineCache: new Map(), generation: 0,
  enabled() { return window.location.pathname.replace(/\/$/,'').endsWith('/collections/accessories'); },
  inputs(root, name) { return [...root.querySelectorAll('input[name="'+name+'"]')]; },
  detail(root, name) { return this.inputs(root,name)[0]?.closest('.js-filter'); },
  count(input) {
    const text = input.closest('label')?.querySelector('.facet-checkbox__content__count')?.textContent;
    const count = Number((text || '').replace(/[^0-9]/g,''));
    return Number.isFinite(count) ? count : 0;
  },
  discover(root) {
    this.inputs(root,this.parent).forEach(input => {
      const text = input.closest('label')?.querySelector('.facet-checkbox__content__label')?.textContent.trim();
      const family = this.aliases[(text || input.value).toLowerCase()];
      if(family) this.parentMap.set(input.value,family);
    });
  },
  state(search) {
    const params = new URLSearchParams(search);
    const families = new Set(params.getAll(this.familyKey));
    params.getAll(this.parent).forEach(v => { const f=this.parentMap.get(v)||this.aliases[v.toLowerCase()];if(f)families.add(f); });
    const desks = new Set([...params.getAll(this.deskKey),...params.getAll(this.desk)]);
    const tables = new Set([...params.getAll(this.tableKey),...params.getAll(this.table)]);
    const sourceValues=params.getAll(this.source);
    // Links without UI metadata, e.g. a native active-filter remove link.
    if(!families.size && sourceValues.length) sourceValues.forEach(v=>families.add(v.split(' | ')[0]));
    if(!params.has(this.familyKey) && !params.has(this.deskKey) && !params.has(this.tableKey)) {
      sourceValues.forEach(v=>{const [f,sub]=v.split(' | ');if(f==='Desks')desks.add(sub);if(f==='Tables')tables.add(sub);});
    }
    if(!families.has('Desks'))desks.clear();
    if(!families.has('Tables'))tables.clear();
    const allowedFamilies=new Set(this.values.map(v=>v.split(' | ')[0]));
    [...families].forEach(f=>{if(!allowedFamilies.has(f))families.delete(f);});
    [...desks].forEach(v=>{if(!this.values.includes('Desks | '+v))desks.delete(v);});
    [...tables].forEach(v=>{if(!this.values.includes('Tables | '+v))tables.delete(v);});
    return {params,families,desks,tables};
  },
  normalize(search) {
    if(!this.enabled())return search;
    const s=this.state(search);const p=s.params;
    [this.parent,this.desk,this.table,this.source,this.familyKey,this.deskKey,this.tableKey].forEach(k=>p.delete(k));
    s.families.forEach(f=>p.append(this.familyKey,f));
    s.desks.forEach(v=>p.append(this.deskKey,v));s.tables.forEach(v=>p.append(this.tableKey,v));
    if(s.families.size) this.values.forEach(v=>{
      const [f,sub]=v.split(' | ');
      if(!s.families.has(f))return;
      if(f==='Desks'&&s.desks.size&&!s.desks.has(sub))return;
      if(f==='Tables'&&s.tables.size&&!s.tables.has(sub))return;
      p.append(this.source,v);
    });
    return p.toString();
  },
  hideCommon(root=document) {
    this.inputs(root,this.source).forEach(i=>{const wrapper=i.closest('.js-filter')?.parentElement;if(wrapper){wrapper.hidden=true;wrapper.style.setProperty('display','none','important');}i.disabled=true;});
  },
  setCount(input,count,checked) {
    input.checked=checked;input.disabled=count===0&&!checked;
    // The prepared DOM is serialized before rendering. Properties alone do not
    // survive outerHTML, so persist checkbox state as HTML attributes as well.
    input.toggleAttribute('checked',checked);
    input.toggleAttribute('disabled',input.disabled);
    const label=input.closest('label');
    label?.classList.toggle('facet-checkbox--disabled',input.disabled);
    const badge=label?.querySelector('.facet-checkbox__content__count');if(badge)badge.textContent=String(count);
  },
  heading(detail,number) {
    let badge=detail.querySelector('.facets__selected');
    if(!badge&&number){
      badge=document.createElement('span');
      badge.className='facets__selected facet-checkbox__content__count flex justify-center align-center lh1 no-js-hidden';
      detail.querySelector('.facets__summary__label')?.append(badge);
    }
    if(badge) {badge.textContent=String(number);badge.hidden=!number;}
    const summary=detail.querySelector('summary');
    if(summary){
      summary.setAttribute('data-ol-selected',String(number));
      const label=summary.getAttribute('aria-label');
      if(label)summary.setAttribute('aria-label',label.replace(/\(\d+/, '('+number));
    }
  },
  sourceChipValue(anchor,search) {
    const text=(anchor.textContent||'').replace(/\s+/g,' ').trim();
    if(/^(remove all|clear all|tout supprimer|tout effacer)/i.test(text))return null;
    const selected=new URLSearchParams(search).getAll(this.source).flatMap(v=>v.split(','));
    const direct=selected.find(v=>text.includes(v));
    if(direct)return direct;
    const href=new URL(anchor.getAttribute('href')||anchor.href,window.location.origin);
    const remaining=href.searchParams.getAll(this.source).flatMap(v=>v.split(','));
    const removed=selected.filter(v=>!remaining.includes(v));
    return removed.length===1?removed[0]:null;
  },
  setChipLabel(anchor,label) {
    const texts=[];
    const walk=node=>{
      if(node.nodeType===3){if(node.textContent.trim())texts.push(node);return;}
      if(node.nodeType!==1)return;
      if(node.tagName?.toLowerCase()==='svg'||node.classList?.contains('visually-hidden'))return;
      [...node.childNodes].forEach(walk);
    };
    walk(anchor);
    if(texts.length){texts[0].textContent=label;texts.slice(1).forEach(n=>n.textContent='');}
    else anchor.prepend(anchor.ownerDocument.createTextNode(label));
  },
  prepare(html,baseline,search) {
    const page=new DOMParser().parseFromString(html,'text/html');
    const base=new DOMParser().parseFromString(baseline,'text/html');
    this.discover(base);
    const s=this.state(search);
    ['FacetFiltersForm','FacetFiltersFormMobile','FacetFiltersPillsForm'].forEach(id=>{
      const form=page.getElementById(id), template=base.getElementById(id);if(!form||!template)return;
      const counts=new Map(this.inputs(template,this.source).map(i=>[i.value,this.count(i)]));
      let insertion=null;
      [this.parent,this.desk,this.table].forEach((name)=>{
        const original=this.detail(template,name);if(!original)return;
        const wrapper=original.parentElement.cloneNode(true);const detail=wrapper.querySelector('.js-filter');
        const current=page.getElementById(original.id);
        if(current)current.parentElement.replaceWith(wrapper);
        else if(insertion)insertion.after(wrapper);
        else {const first=form.querySelector('.js-filter');if(first)first.parentElement.before(wrapper);else return;}
        if(name===this.parent) {
          this.inputs(wrapper,name).forEach(i=>{
            const family=this.parentMap.get(i.value);
            if(!family)throw Error('Unmapped Product Type: '+i.value);
            i.name=this.familyKey;i.value=family;
            const count=this.values.filter(v=>v.startsWith(family+' | ')).reduce((a,v)=>a+(counts.get(v)||0),0);
            this.setCount(i,count,s.families.has(family));
          });
          this.heading(detail,s.families.size);
        } else {
          const family=name===this.desk?'Desks':'Tables';const selected=family==='Desks'?s.desks:s.tables;
          this.inputs(wrapper,name).forEach(i=>{const value=i.value;i.name=family==='Desks'?this.deskKey:this.tableKey;this.setCount(i,counts.get(family+' | '+value)||0,selected.has(value));});
          wrapper.hidden=!s.families.has(family);if(wrapper.hidden)wrapper.style.setProperty('display','none','important');
          this.heading(detail,selected.size);
        }
        if(insertion)insertion.after(wrapper);insertion=wrapper;
        // Reset links must remove only the matching visual section.
        wrapper.querySelectorAll('facet-remove a').forEach(a=>{
          const p=new URLSearchParams(search);
          if(name===this.parent){[this.familyKey,this.deskKey,this.tableKey,this.source].forEach(k=>p.delete(k));}
          else p.delete(name===this.desk?this.deskKey:this.tableKey);
          a.href=window.location.pathname+'?'+this.normalize(p.toString());
        });
      });
    });
    this.hideCommon(page);
    // Identify the source chip by its value as well as its remove URL. Shopify
    // can combine same-source values into a comma-separated query parameter.
    page.querySelectorAll('.active-facets-desktop a, .active-facets-mobile a').forEach(a=>{
      const value=this.sourceChipValue(a,search);
      if(!value)return;
      const [family,sub]=value.split(' | ');
      const p=new URLSearchParams(search);
      const key=family==='Desks'?this.deskKey:family==='Tables'?this.tableKey:null;
      const active=key?p.getAll(key):[];
      if(key&&active.length){p.delete(key);active.filter(v=>v!==sub).forEach(v=>p.append(key,v));}
      else {const keep=p.getAll(this.familyKey).filter(v=>v!==family);p.delete(this.familyKey);keep.forEach(v=>p.append(this.familyKey,v));if(key)p.delete(key);}
      // Do not let residual source values recreate a removed family.
      p.delete(this.source);a.href=window.location.pathname+'?'+this.normalize(p.toString());
      const publicFamily=family==='Tables'?'Accent & Side Tables':family;
      const publicLabel=!active.length||sub==='All'?publicFamily:sub;
      this.setChipLabel(a,publicLabel);
      a.setAttribute('aria-label','Remove '+publicLabel);
      if(!active.length)(a.closest('facet-remove')||a).setAttribute('data-ol-whole-family',family);
    });
    page.querySelectorAll('.active-facets-desktop, .active-facets-mobile').forEach(container=>{
      const seen=new Set();container.querySelectorAll('[data-ol-whole-family]').forEach(chip=>{
        const family=chip.getAttribute('data-ol-whole-family');if(seen.has(family))chip.remove();else seen.add(family);
      });
    });
    return '<!doctype html>'+page.documentElement.outerHTML;
  },
  async baseline(search) {
    const p=new URLSearchParams(search);
    [this.parent,this.desk,this.table,this.source,this.familyKey,this.deskKey,this.tableKey,'page'].forEach(k=>p.delete(k));
    p.set('section_id',FacetFiltersForm.getSections()[0].section);
    const url=window.location.pathname+'?'+p.toString();
    if(!this.baselineCache.has(url)) {
      const promise=fetch(url).then(r=>{if(!r.ok)throw Error('Facet baseline '+r.status);return r.text();});
      this.baselineCache.set(url,promise);promise.catch(()=>this.baselineCache.delete(url));
    }
    return this.baselineCache.get(url);
  },
  syncVisibleSections(search) {
    const state=this.state(search);
    document.querySelectorAll('facet-filters-form form').forEach(form=>{
      const parent=this.detail(form,this.familyKey);
      let insertion=parent?.parentElement;
      this.inputs(form,this.familyKey).forEach(input=>{
        input.checked=state.families.has(input.value);
        input.toggleAttribute('checked',input.checked);
      });
      [[this.deskKey,'Desks',state.desks],[this.tableKey,'Tables',state.tables]].forEach(([key,family,selected])=>{
        const detail=this.detail(form,key);
        const wrapper=detail?.parentElement;if(!wrapper)return;
        const visible=state.families.has(family);
        if(!visible&&wrapper.contains(document.activeElement))parent?.querySelector('summary')?.focus({preventScroll:true});
        wrapper.hidden=!visible;
        if(visible)wrapper.style.removeProperty('display');
        else wrapper.style.setProperty('display','none','important');
        this.inputs(form,key).forEach(input=>{
          input.checked=visible&&selected.has(input.value);
          input.toggleAttribute('checked',input.checked);
        });
        if(insertion&&insertion.parentElement===wrapper.parentElement){
          if(insertion.nextElementSibling!==wrapper)insertion.after(wrapper);
          insertion=wrapper;
        }
      });
    });
    this.hideCommon();
  },
  async render(html,search,generation) {
    const baseline=await this.baseline(search);if(generation!==this.generation)return;
    const open=new Set([...document.querySelectorAll('.js-filter[open]')].map(d=>d.id));
    const focused=document.activeElement?.id;
    const prepared=this.prepare(html,baseline,search);
    this.originalRenderFilters.call(FacetFiltersForm,prepared,null);
    // This theme also includes the active-facets snippet inside the product-grid
    // response. Inserting the raw response here would undo the label cleanup.
    FacetFiltersForm.renderProductGridContainer(prepared);
    FacetFiltersForm.renderProductCount(prepared);
    // Restore the prepared chips after every container replacement, not before.
    FacetFiltersForm.renderActiveFacets(new DOMParser().parseFromString(prepared,'text/html'));
    document.querySelectorAll('.js-filter').forEach(d=>{d.open=open.has(d.id);});
    this.syncVisibleSections(search);
    if(focused){const target=document.getElementById(focused);if(target&&!target.closest('[hidden]'))target.focus({preventScroll:true});}
  },
  fail(error) {
    console.error('Ortholuxe Accessories OR:',error);
    document.getElementById('ProductGridContainer')?.querySelector('.collection')?.classList.remove('loading');
    FacetFiltersForm.toggleActiveFacets(false);
    let note=document.getElementById('OrtholuxeFilterError');
    if(!note){note=document.createElement('p');note.id='OrtholuxeFilterError';note.setAttribute('role','alert');document.getElementById('ProductGridContainer')?.prepend(note);}
    note.textContent='Filters could not be updated. Please refresh the page.';
  },
  install() {
    const engine=this;
    this.originalRenderFilters=FacetFiltersForm.renderFilters;
    FacetFiltersForm.renderFilters=function(html,event){
      engine.originalRenderFilters.call(this,html,event);
      engine.hideCommon();
    };
    const originalPage=FacetFiltersForm.renderPage;
    FacetFiltersForm.renderPage=function(search,event,update=true){
      if(!engine.enabled())return originalPage.call(this,search,event,update);
      document.getElementById('OrtholuxeFilterError')?.remove();
      const normalized=engine.normalize(search);engine.generation++;
      return originalPage.call(this,normalized,event,update);
    };
    const originalFetch=FacetFiltersForm.renderSectionFromFetch;
    FacetFiltersForm.renderSectionFromFetch=function(url,event){
      if(!engine.enabled())return originalFetch.call(this,url,event);
      const generation=engine.generation,search=FacetFiltersForm.searchParamsPrev;
      fetch(url).then(r=>{if(!r.ok)throw Error('Facets '+r.status);return r.text();}).then(html=>{
        if(generation!==engine.generation)return;
        FacetFiltersForm.filterData.push({html,url});return engine.render(html,search,generation);
      }).catch(e=>{if(generation===engine.generation)engine.fail(e);});
    };
    const originalCache=FacetFiltersForm.renderSectionFromCache;
    FacetFiltersForm.renderSectionFromCache=function(predicate,event){
      if(!engine.enabled())return originalCache.call(this,predicate,event);
      const generation=engine.generation;
      engine.render(FacetFiltersForm.filterData.find(predicate).html,FacetFiltersForm.searchParamsPrev,generation).catch(e=>{if(generation===engine.generation)engine.fail(e);});
    };
    // Clear dependent picks immediately, before the theme's existing debounced submission.
    document.addEventListener('input',event=>{
      if(!engine.enabled()||event.target.name!==engine.familyKey)return;
      const form=event.target.closest('form');if(!form)return;
      ['Desks','Tables'].forEach(f=>{
        const parent=engine.inputs(form,engine.familyKey).find(i=>i.value===f);
        if(!parent?.checked)engine.inputs(form,f==='Desks'?engine.deskKey:engine.tableKey).forEach(i=>i.checked=false);
      });
    },true);
    const init=()=>{
      engine.hideCommon();if(!engine.enabled())return;
      engine.discover(document);
      const old=window.location.search.slice(1),normalized=engine.normalize(old);
      // Replace, rather than append, initial history entry when migrating old links.
      if(normalized!==old)history.replaceState({searchParams:normalized},'',window.location.pathname+(normalized?'?'+normalized:''));
      FacetFiltersForm.renderPage(normalized,null,false);
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
    document.addEventListener('shopify:section:load',init);
  }
};

OrtholuxeAccessoryOR.values = ["Artificial Plants | All","Clocks | All","Coat Racks | All","Coffee Tables | All","Console Tables | All","Curtains & Cushions | All","Desks | Compact Desks","Desks | Corner & L-Shaped Desks","Desks | Desks with Shelves & Hutch","Desks | Desks with Storage","Desks | Ladder Desks","Desks | Secretary Desks","Desks | Standing & Adjustable Desks","Desks | Straight Desks","Desks | Writing & Study Desks","Lighting | All","Mirrors | All","Office Workstations | All","Step Stools | All","Tables | C-Shaped Tables","Tables | Coffee Tables","Tables | Console Tables","Tables | Decorative & Sculptural Tables","Tables | Nesting Tables","Tables | Round Tables","Tables | Square & Rectangular Tables","Tables | Tables with Shelves","Tables | Tables with Storage"]
;
OrtholuxeAccessoryOR.install();
